import React from 'react';
import ForgotPassword from '../Views/Login/ForgotPassword';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

ReactGA.pageview(window.location.pathname + window.location.search);
const ForgetPasswordView = (props) => {
   const endingForgetPassword = (boo) => {
      if (boo) {
         props.history.push('/');
      }
   };
   return <ForgotPassword endingForgetPassword={endingForgetPassword} />;
};

export default withRouter(ForgetPasswordView);
